// extracted by mini-css-extract-plugin
export default {"dismiss-button":"DismissButton_dismiss-button__3uxsH"};